import { apiEndpoint } from '@/config';
import { useRouter } from '@/i18n/routing';
import { useAuth } from '@/lib/auth/use-auth';
import { fetcher } from '@/lib/swr';
import {
  ApiErrorResponse,
  ApiSuccessResponse,
  LessonViewModel,
} from '@hidayahlab/academy-suite-corelib';
import useSWR from 'swr';

export function useGetLesson(lessonId?: number, batchId?: number) {
  const { token } = useAuth();
  const router = useRouter();

  const shouldFetch = !!token && !!lessonId;
  const apiUrl = shouldFetch
    ? `${apiEndpoint}/lessons/${lessonId}?batchId=${batchId}`
    : null;

  const { data, error, isLoading } = useSWR<
    ApiSuccessResponse<LessonViewModel>,
    ApiErrorResponse
  >(apiUrl, (url: string) => fetcher(url, token));

  if (data?.statusCode === 401) {
    router.push('/logout');
  }

  return {
    data: data?.data,
    isLoading,
    isError: error,
  };
}

export const useGetFreeLessonById = (id: number) => {
  const apiUrl = `${apiEndpoint}/lessons/free/${id}`;

  const { data, error, isLoading } = useSWR<
    ApiSuccessResponse<LessonViewModel>,
    ApiErrorResponse
  >(apiUrl, (url: string) => fetcher(url));

  return {
    data: data?.data,
    isLoading,
    isError: error,
  };
};
